import i18n from "@/app/i18n";

export namespace UI {
  export type State =
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "danger";

  export const stateTextColor = {
    primary: "text-primary-500",
    secondary: "text-gray-500",
    success: "text-green-500",
    warning: "text-yellow-500",
    danger: "text-red-500",
  };

  export const stateBackgroundColor = {
    primary: "bg-blue-100",
    secondary: "bg-gray-100",
    success: "bg-green-100",
    warning: "bg-yellow-100",
    danger: "bg-red-100",
  };

  export const formatCurrency = (amount: number, currency: string) => {
    return new Intl.NumberFormat(i18n.language, {
      style: "currency",
      currency,
    }).format(amount);
  };
}
